import { gql } from '@apollo/client';

// 企業を作成するミューテーション
export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      companyId
      name
      contractStartDate
      contractEndDate
      maxUsers
      contactInfo
      notes
      ssoSecret
      usageCount
      deletable
      createdAt
      updatedAt
    }
  }
`;

// 企業を更新するミューテーション
export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      companyId
      name
      contractStartDate
      contractEndDate
      maxUsers
      contactInfo
      notes
      ssoSecret
      usageCount
      deletable
      createdAt
      updatedAt
    }
  }
`;

// 企業を削除するミューテーション
export const DELETE_COMPANY = gql`
  mutation DeleteCompany($companyId: ID!) {
    deleteCompany(companyId: $companyId)
  }
`;

// ユーザーを作成するミューテーション
export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      userId
      givenUserId
      tempPassword
      email
      displayName
      companyId
      departments
      managementScope
      profileId
      lastLoginDate
      disable
      locked
      userRole
      createdAt
      updatedAt
    }
  }
`;

// ユーザーを更新するミューテーション
export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      userId
      givenUserId
      tempPassword
      email
      displayName
      companyId
      departments
      managementScope
      profileId
      lastLoginDate
      disable
      locked
      userRole
      createdAt
      updatedAt
    }
  }
`;

// ユーザー一括取り込み（同一企業・最大1000件）
export const BULK_IMPORT_USERS = gql`
  mutation BulkImportUsers($input: BulkImportUsersInput!) {
    bulkImportUsers(input: $input) {
      validationFailed
      validationErrors {
        rowIndex
        givenUserId
        message
      }
      capacityCheckFailed
      createdCount
      updatedCount
      skippedCount
      processingErrors {
        rowIndex
        givenUserId
        message
      }
    }
  }
`;

// ユーザーを削除するミューテーション
export const DELETE_USER = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId)
  }
`;

// ユーザーを有効化するミューテーション
export const ENABLE_USER = gql`
  mutation EnableUser($userId: ID!) {
    enableUser(userId: $userId) {
      userId
    }
  }
`;

// ユーザーを無効化するミューテーション
export const DISABLE_USER = gql`
  mutation DisableUser($userId: ID!) {
    disableUser(userId: $userId) {
      userId
    }
  }
`;

// シナリオを作成するミューテーション
export const CREATE_SCENARIO = gql`
  mutation CreateScenario($input: CreateScenarioInput!) {
    createScenario(input: $input) {
      scenarioId
      companyId
      department
      title
      description
      goal
      estimatedTime
      situation
      targetName
      targetGender
      targetAge
      targetLanguage
      tags
      isActive
      showMaterialsOnOrientation
      situationClosed
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// シナリオを更新するミューテーション
export const UPDATE_SCENARIO = gql`
  mutation UpdateScenario($input: UpdateScenarioInput!) {
    updateScenario(input: $input) {
      scenarioId
      companyId
      department
      title
      description
      goal
      estimatedTime
      situation
      targetName
      targetGender
      targetAge
      targetLanguage
      tags
      isActive
      displayOrder
      showMaterialsOnOrientation
      situationClosed
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// シナリオの順序を更新するミューテーション
export const UPDATE_SCENARIO_ORDER = gql`
  mutation UpdateScenarioOrder($input: UpdateScenarioOrderInput!) {
    updateScenarioOrder(input: $input) {
      scenarioId
      displayOrder
    }
  }
`;

// シナリオを削除するミューテーション
export const DELETE_SCENARIO = gql`
  mutation DeleteScenario($scenarioId: ID!) {
    deleteScenario(scenarioId: $scenarioId)
  }
`;

// 資料を作成するミューテーション
export const CREATE_MATERIAL = gql`
  mutation CreateMaterial($input: CreateMaterialInput!) {
    createMaterial(input: $input) {
      companyId
      parentScenarioId
      name
      type
      pdfPath
      extractedText
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// 資料を更新するミューテーション
export const UPDATE_MATERIAL = gql`
  mutation UpdateMaterial($input: UpdateMaterialInput!) {
    updateMaterial(input: $input) {
      materialId
      companyId
      parentScenarioId
      name
      type
      pdfPath
      extractedText
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// 資料を削除するミューテーション
export const DELETE_MATERIAL = gql`
  mutation DeleteMaterial($materialId: ID!) {
    deleteMaterial(materialId: $materialId)
  }
`;

// カスタム評価ルールを作成するミューテーション
export const CREATE_CUSTOM_EVALUATION_RULE = gql`
  mutation CreateCustomEvaluationRule($input: CreateCustomEvaluationRuleInput!) {
    createCustomEvaluationRule(input: $input) {
      ruleId
      companyId
      parentScenarioId
      name
      content
      displayOrder
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// カスタム評価ルールを更新するミューテーション
export const UPDATE_CUSTOM_EVALUATION_RULE = gql`
  mutation UpdateCustomEvaluationRule($input: UpdateCustomEvaluationRuleInput!) {
    updateCustomEvaluationRule(input: $input) {
      ruleId
      companyId
      parentScenarioId
      name
      content
      displayOrder
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// カスタム評価ルールの順序を更新するミューテーション
export const UPDATE_CUSTOM_EVALUATION_RULES_ORDER = gql`
  mutation UpdateCustomEvaluationRulesOrder($input: UpdateCustomEvaluationRulesOrderInput!) {
    updateCustomEvaluationRulesOrder(input: $input) {
      ruleId
      displayOrder
    }
  }
`;

// カスタム評価ルールを削除するミューテーション
export const DELETE_CUSTOM_EVALUATION_RULE = gql`
  mutation DeleteCustomEvaluationRule($ruleId: ID!) {
    deleteCustomEvaluationRule(ruleId: $ruleId)
  }
`;

// セッションを開始するミューテーション
export const START_SESSION = gql`
  mutation StartSession($input: StartSessionInput!) {
    startSession(input: $input) {
      sessionId
      userId
      scenarioId
      companyId
      department
      startTime
      endTime
      status
      characterSettings
      aiGuide
      aiSubtitleDisplay
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// セッションを更新するミューテーション
export const UPDATE_SESSION = gql`
  mutation UpdateSession($input: UpdateSessionInput!) {
    updateSession(input: $input) {
      sessionId
      userId
      scenarioId
      companyId
      department
      startTime
      endTime
      status
      characterSettings
      aiGuide
      aiSubtitleDisplay
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// セッションを終了するミューテーション
export const END_SESSION = gql`
  mutation EndSession($sessionId: ID!) {
    endSession(sessionId: $sessionId) {
      sessionId
      userId
      scenarioId
      companyId
      department
      startTime
      endTime
      status
      characterSettings
      aiGuide
      aiSubtitleDisplay
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// 会話を生成するミューテーション
export const GENERATE_CONVERSATION = gql`
  mutation GenerateConversation($input: GenerateConversationInput!) {
    generateConversation(input: $input) {
      conversationId
      sessionId
      counter
      userContent
      aiContent
      aiParams
      aiGuide
      status
      userAudioPath
      aiAudioPath
      createdAt
      updatedAt
    }
  }
`;

// 会話を更新するミューテーション
export const UPDATE_CONVERSATION = gql`
  mutation UpdateConversation($input: UpdateConversationInput!) {
    updateConversation(input: $input) {
      conversationId
      sessionId
      counter
      userContent
      aiContent
      aiParams
      aiGuide
      status
      userAudioPath
      aiAudioPath
      createdAt
      updatedAt
    }
  }
`;

// 問合せを作成するMutation
export const CREATE_INQUIRY = gql`
  mutation CreateInquiry($input: CreateInquiryInput!) {
    createInquiry(input: $input) {
      inquiryId
      category
      contactName
      contactEmail
      contactCompany
      contactBody
      status
      createdBy
      createdAt
      updatedAt
    }
  }
`;

// ユーザーパスワードをリセットするミューテーション
export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($input: ResetUserPasswordInput!) {
    resetUserPassword(input: $input) {
      userId
      success
      message
    }
  }
`;

// プロファイルを作成するミューテーション
export const CREATE_PROFILE = gql`
  mutation CreateProfile($input: CreateProfileInput!) {
    createProfile(input: $input) {
      profileId
      companyId
      name
      description
      permissions {
        userMgmt {
          view { canView canCsvDownload }
          edit { canCreateNew canCsvImport canBulkUpdate canUpdate canDelete canChangePassword }
        }
        scenarioMgmt {
          view { canView canCsvDownload }
          edit { canCreateNew canCsvImport canUpdate canDelete canCustomScenarioUpdate }
        }
        analytics {
          view { canView canCsvDownload }
        }
        profileMgmt {
          view { canView }
          edit { canCreateNew canUpdate canDelete }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// プロファイルを更新するミューテーション
export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      profileId
      companyId
      name
      description
      permissions {
        userMgmt {
          view { canView canCsvDownload }
          edit { canCreateNew canCsvImport canBulkUpdate canUpdate canDelete canChangePassword }
        }
        scenarioMgmt {
          view { canView canCsvDownload }
          edit { canCreateNew canCsvImport canUpdate canDelete canCustomScenarioUpdate }
        }
        analytics {
          view { canView canCsvDownload }
        }
        profileMgmt {
          view { canView }
          edit { canCreateNew canUpdate canDelete }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// プロファイルを削除するミューテーション
export const DELETE_PROFILE = gql`
  mutation DeleteProfile($profileId: ID!) {
    deleteProfile(profileId: $profileId)
  }
`;

// ロープレ情報を一括更新するミューテーション
export const BULK_UPDATE_SCENARIOS = gql`
  mutation BulkUpdateScenarios($input: BulkUpdateScenariosInput!) {
    bulkUpdateScenarios(input: $input) {
      successCount
      errorCount
      errors {
        scenarioId
        message
      }
    }
  }
`;

// CSVダウンロードリクエストを作成するミューテーション
export const CREATE_CSV_DOWNLOAD_REQUEST = gql`
  mutation CreateCsvDownloadRequest($input: CreateCsvDownloadRequestInput!) {
    createCsvDownloadRequest(input: $input) {
      requestId
      companyId
      requestType
      requestData
      status
      resultCsvPath
      fileName
      createdBy
      createdAt
      updatedAt
    }
  }
`;
